import { ViewIcon } from '../../assets/images';

const EmptyViewersState = () => {
    return (
        <div className="no-viewers-empty-state">
            <div className="no-viewers-icon-circle">
                <ViewIcon />
            </div>
            <p className="no-viewers-label">No views yet</p>
        </div>
    );
};

export default EmptyViewersState;
